import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { AuthButton } from "../../pages/auth/Login.style";
import { BsArrowLeftShort } from "react-icons/bs";
import { GoBackDiv } from "../../pages/student_mgt/stu_mgt.style";
import CreateParentForm from "./CreateParentForm";
import CreateParentList from "./CreateParentList";
import { createParent, updateParentProfile } from "../../services/ParentStudent";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ErrorService from "../../services/errorService";

const CreateParent = () => {
  const [showForm, setShowForm] = useState(false);
  const isTab = useMediaQuery({ maxWidth: 992 });
  const { admToken } = useSelector((state) => state.auth);
  const [formLoading, setFormLoading] = useState(false);

  const [obj, setObj] = useState({
    fullName: "",
    title: "",
    email: "",
    officeAddress: "",
    placeOfWork: "",
    dateOfBirth: null,
    nameOfChildren: "",
    phoneNumber: "",
    residentialAddress: "",
    studentId: 0,
    schoolId: 0,
    relationShip: "",
    postalAddress: "",
    permanentAddress: "nil",
    profession: "nil",
    statusRankDesignation: "",
    profileImagePath: "",
    accountStatus: "0",
    religion: "",
    placeOfWorship: "",
    denomination: "",
    statusInPlaceOfWorship: "",
    placeOfBirth: "",
    permanentHomeAddress: "",
    nearestBusstop: "",
    educationalQualification: "",
    occupation: "",
    nationality: "",
    stateOfOrigin: "",
    lg: "",
    homeTown: "",
    createdBy: "N",
  });

  const createParentFunc = async () => {
    console.log(obj);
    // let formIsValid = isObjEmpty(obj);
    // if (!formIsValid) {
    //   return toast.error("Please Make Sure You Fill All The Form");
    // }
    try {
      setFormLoading(true);
      const res = await createParent(admToken, obj);
      console.log(res);
      setFormLoading(false);
      res.status &&
        res.statusCode === 2 &&
        toast.success(res.data, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        }) &&
        setShowForm(false);
      (!res.status || res.status === 400) &&
        ErrorService.displayErrorAlert(res);
    } catch (error) {
      setFormLoading(false);
      console.log(error);
      toast.error("An Error Ocurred, Try Again Later");
    }
  };

  return (
    <div style={{ marginTop: "0.6rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: !showForm ? "end" : "start",
        }}
      >
        {!showForm ? (
          <AuthButton
            mt="0.6rem"
            pl="0px"
            width={isTab ? "50%" : "30%"}
            onClick={() => setShowForm(prev => !prev)}
          >
            <div>
              <span>Create New Parent</span>
            </div>
            {/* Send Code */}
          </AuthButton>
        ) : (
          <GoBackDiv
            onClick={() => setShowForm(prev => !prev)}
            style={{
              cursor: "pointer",
            }}
          >
            <div>
              <BsArrowLeftShort />
            </div>
            <span>Back To Parent List</span>
          </GoBackDiv>
        )}
      </div>
      
      <>{!showForm && <CreateParentList />}</>
      {/* {!showForm && <div>LIST</div>} */}
      <>
        {showForm && (
          <CreateParentForm
            showFormFunc={setShowForm}
            formLoading={formLoading}
            obj={obj}
            setObj={setObj}
            action={createParentFunc}
            readOnly={false}
            isEdit={false}
          />
        )}
        {/* {!showForm && <div>LIST</div>} */}
      </>
    </div>
  );
};

export default CreateParent;
